import ScalarTextInput_vue_vue_type_script_setup_true_lang_default from "./ScalarTextInput.vue.script.js";
//#region src/components/ScalarTextInput/ScalarTextInput.vue
var ScalarTextInput_default = ScalarTextInput_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarTextInput_default as default };

//# sourceMappingURL=ScalarTextInput.vue.js.map